import { Box } from '@chakra-ui/react'
import { motion } from 'framer-motion'
import React from 'react'

export const SidePanel = ({
  isVisible,
  children,
  width = '520px',
  position = 'right'
}: {
  isVisible: boolean
  children?: React.ReactNode
  width?: string
  position?: 'left' | 'right'
}) => {
  const variants = {
    open: {
      x: 0,
      width,
      opacity: 1
    },
    closed: {
      x: position === 'right' ? width : `-${width}`,
      width: '0px',
      opacity: 0
    }
  }

  return (
    <Box
      py={isVisible ? '16px' : '0px'}
      pr={isVisible ? '16px' : '0px'}
      transition="all 0.3s ease-in-out"
    >
      <motion.div
        style={{
          height: '100%',
          backgroundColor: 'white',
          borderRadius: '16px',
          overflow: 'hidden',
          position: 'relative',
          flexShrink: 0,
          boxSizing: 'content-box'
        }}
        variants={variants}
        initial="closed"
        animate={isVisible ? 'open' : 'closed'}
        transition={{ duration: 0.3, ease: 'easeInOut' }}
      >
        {children}
      </motion.div>
    </Box>
  )
}
